function GetLanguage(useParent) {
    var userLanguage = "en-US";

    var cookie = getCookie("layout");
    var cookies = cookie.split("&");
    for (var i = 0; i < cookies.length; i++) {
        var dateIndex = cookies[i].indexOf("userLanguage=");
        if (dateIndex > -1) {
            userLanguage = cookies[i].substring(13);
            break;
        }
    }

    if (useParent) {
        var indexOfDash = userLanguage.indexOf('-');
        if (indexOfDash > -1) {
            userLanguage = userLanguage.substring(0, indexOfDash);
        }
    }

    return userLanguage;
}

function GetUserDateFormat(originalCase) {
    var userDateFormat = "MM/DD/YYYY";

    var cookie = getCookie("layout");
    var cookies = cookie.split("&");
    for (var i = 0; i < cookies.length; i++) {
        var dateIndex = cookies[i].indexOf("userDateFormat=");
        if (dateIndex > -1) {
            if (originalCase)
                userDateFormat = cookies[i].substring(15);
            else
                userDateFormat = cookies[i].substring(15).toUpperCase();
            break;
        }
    }

    return userDateFormat;
}

function GetUserDateTimeFormat () {
    var userDateFormat = "MM/DD/YYYY";
    var userTimeFormat = "hh:mm A";

    var cookie = getCookie("layout");
    var cookies = cookie.split("&");
    for (var i = 0; i < cookies.length; i++) {
        var dateIndex = cookies[i].indexOf("userDateFormat=");
        var timeIndex = cookies[i].indexOf("userTimeFormat=");

        if (dateIndex > -1) {
            userDateFormat = cookies[i].substring(15).toUpperCase();
        }

        if (timeIndex > -1) {
            userTimeFormat = cookies[i].substring(15);
            userTimeFormat = userTimeFormat.replace("tt", "A");
        }
    }

    return userDateFormat + " " + userTimeFormat;
}

function GetUserTimeZone() {
    var userTimeZone = "America/New_York";

    var cookie = getCookie("layout");
    var cookies = cookie.split("&");
    for (var i = 0; i < cookies.length; i++) {
        var dateIndex = cookies[i].indexOf("userTimeZone=");
        if (dateIndex > -1) {
            userTimeZone = cookies[i].substring(13);
            break;
        }
    }

    return userTimeZone;
}

function GetTimeFormat() {
    return Show24Hours() ? "HH:mm" : "hh:mm A";
}

function Show24Hours() {
    var show24Hours = true;
    var cookie = getCookie("layout");
    var cookies = cookie.split("&");

    for (var i = 0; i < cookies.length; i++) {
        var timeIndex = cookies[i].indexOf("userTimeFormat=");
        
        if (timeIndex > -1) {
            var userTimeFormat = cookies[i].substring(15);
            if (userTimeFormat.indexOf("tt") > -1)
                show24Hours = false;
        }
    }

    return show24Hours;
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function ConvertFromUtcToLocalDateTimeFromNow(utcDateTime) {
    try {
        var justNow = "Just Now";

        var userTimeZone = GetUserTimeZone();
        var localDateTimeFromNow = moment.utc(utcDateTime).tz(userTimeZone).fromNow();

        if (localDateTimeFromNow.indexOf(justNow) > -1)
            localDateTimeFromNow = moment.utc(utcDateTime).tz(userTimeZone).fromNow(true);

        return localDateTimeFromNow;
    } catch (e) {
        console.log(e);

        return utcDateTime;
    }
}

function ConvertFromUtcToLocalDateWithUserFormat(utcDateTime) {
    try {
        var userTimeZone = GetUserTimeZone();
        var localDate = moment.utc(utcDateTime).tz(userTimeZone).toDate();
        var userdateFormat = GetUserDateFormat();

        return formatDateTime(localDate, userdateFormat);
    } catch (e) {
        console.log(e);

        return utcDateTime;
    }
}

function formatDateTime(dateTime, dateTimeFormat) {
    return moment(dateTime).format(dateTimeFormat);
}